<div class="archive-trades">
  <button
    *ngIf="!allTradesArchived; else allTradesArchivedTmpl"
    type="button"
    class="ui-button ui-button--archive-trades"
    (click)="archiveTrades()"
    [disabled]="!tradesToArchive?.length"
  >
    <span *ngIf="!state; else archivingTrades">
      {{
        tradesToArchive?.length || 0
          | i18nPlural
            : {
                '=0': 'No trades selected for archiving',
                '=1': 'Archive selected trade',
                other: 'Archive selected trades'
              }
      }}
    </span>
    <ng-template #archivingTrades>
      <span class="spinner spinner-sm spinner-inverse"> </span>
    </ng-template>
  </button>

  <ng-template #allTradesArchivedTmpl>
    <div class="archive-trades__archived">
      <span> Selected trades have been archived </span>
      <button type="button" class="ui-button" (click)="goBack()">Back</button>
    </div>
  </ng-template>
</div>
